export const GENERAL_RESET_FORM_FACTURE = "GENERAL_RESET_FORM_FACTURE";
export const GENERAL_RESET_FORM_BORDEREAU = "GENERAL_RESET_FORM_BORDEREAU";
export const GENERAL_RESET_FORM_CONTRAT = "GENERAL_RESET_FORM_CONTRAT";
export const GENERAL_RESET_FORM_TIER = "GENERAL_RESET_FORM_TIER";
export const GENERAL_RESET_FORM_MARCHE = "GENERAL_RESET_FORM_MARCHE";
export const GENERAL_RESET_FORM_COMMANDE = "GENERAL_RESET_FORM_COMMANDE";
export const GENERAL_RESET_FORM_OD = "GENERAL_RESET_FORM_OD";
export const GENERAL_RESET_FORM_MISSION = "GENERAL_RESET_FORM_MISSION";
export const GENERAL_RESET_FORM_AUTREDOCUMENTCOMPTABLE =
  "GENERAL_RESET_FORM_AUTREDOCUMENTCOMPTABLE";
